module.exports = __webpack_public_path__ + "static/media/mkcompat_900.a3d69a1d.ico";